import {Component, OnInit} from '@angular/core';
import {template} from "suneditor/src/plugins";
import {TemplateComponent} from "../../template/template.component";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-abstract',
  standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
  templateUrl: './abstract.component.html',
  styleUrl: './abstract.component.css'
})
export class AbstractComponent extends TemplateComponent  implements OnInit  {

  abstract_bar:any[];


  ngOnInit() {
    this.abstract_bar = this.global.getMainData()['main-page'] != null ?JSON.parse(this.global.getMainData()['main-page']['data'])['abstract-bar']:'';
    setTimeout(()=>{
      this.abstract_bar = this.global.getMainData()['main-page']!= null ? JSON.parse(this.global.getMainData()['main-page']['data'])['abstract-bar']:'';
    },1000)
  }
}
